<template>
  <base-button type="submit" class="btn-primary" text="編集" />
</template>

<script>
import BaseButton from '@/views/atoms/BaseButton';

export default {
  name: 'EditButton',
  components: {
    BaseButton,
  },
}
</script>
